/**
 * Returns true if two arrays contains the same values. Otherwise, false.
 * @param {Array} a array
 * @param {Array} b array to compare
 * @returns {boolean} true or false
 */
function arrayEquals(a, b) {
  return (
    Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((val, index) => val === b[index])
  );
}

/**
 * Get a wrapper array if the entry value is not an array. Utility to assure
 * that an unknown value can be read as an array.
 * @param {*} val - target value
 * @returns {Array} - Array
 */
function arrify(val) {
  if (val === null || val === undefined) {
    return [];
  }
  return Array.isArray(val) ? val : [val];
}

/**
 * Sorts an array of numbers
 * @param {number[]} arrayOfNumbers - The source array
 * @return {number[]} A new sorted copy of the array
 */
const sortArrayOfNumbers = (arrayOfNumbers) =>
  arrayOfNumbers
    .map((i) => +i) // Make a copy (and parse numeric strings to number)
    .sort((a, b) => a - b); // Sorts the copy and retuns it

export { arrayEquals, arrify, sortArrayOfNumbers };
